module.exports = __webpack_public_path__ + "img/tank-base-mask-3.ab257bd8.png";